import React, { useEffect, useState } from 'react';
import serviceMap from '../../Content/Data/Services//Info/serviceMap.json';
import contactUsJson from '../../Content/Data/ContactUs/contactUs.json';

function Services(props) {

    const [serviceDetails, setServiceDetails] = useState(null);
    const [selectedTopbarItem, setSelectedTopbarItem] = useState(null);
    const [selectedSubTopbarItem, setSelectedSubTopbarItem] = useState(null);

    useEffect(() => {
        if (document.location.pathname.includes("/services")) {
            let service;
            if (document.location.search.split("?")[1].includes("&")) {
                service = document.location.search.split("?")[1].split("&")[1] ? document.location.search.split("?")[1].split("&")[1].split("=")[1] : document.location.search.split("?")[1].split("&")[0].split("=")[0];
            }
            else {
                service = document.location.search.split("?")[1].split("=")[1];
            }
            loadData(service);
        }
    }, [props.isPathChanged]);

    const loadData = async (service) => {
        try {
            const module = await import(`../../Content/Data/Services/Data/${serviceMap[service]}.json`);
            let serviceDetail = {
                ...module,
                "Features": module.Features.map((x, i) => {
                    return {
                        ...x,
                        "id": `service${i}`,
                        "isSelected": i === 0,
                        "Features": x.Features.map((y, j) => {
                            return {
                                ...y,
                                "id": `servicesub${j}`,
                                "isSelected": i === 0 && j === 0
                            };
                        })
                    };
                })
            };
            setServiceDetails(serviceDetail);
            setSelectedTopbarItem(serviceDetail.Features[0].Features[0]);
            setSelectedSubTopbarItem(serviceDetail.Features[0]);
        } catch (error) {
            console.error("Failed to load service:", error);
        }
    };

    function handleSubTopbarClick(event, item) {
        setSelectedTopbarItem(item.Features[0]);
        setSelectedSubTopbarItem(item);
    }

    function handleTopbarClick(event, item) {
        setSelectedTopbarItem(item);
    }

    function getSubTopbar() {
        return (
            <div className="services-sub-topbar">
                {
                    serviceDetails.Features.map((x, i) => {
                        return (
                            x.Heading ?
                                <div
                                    key={i}
                                    id={x.id}
                                    className={x.id === selectedSubTopbarItem.id ? "services-sub-topbar-item services-sub-topbar-item-active" : "services-sub-topbar-item"}
                                    onClick={(event) => { handleSubTopbarClick(event, x) }}
                                >
                                    {x.Heading}
                                </div>
                                : ""
                        )
                    })
                }
            </div>
        );
    }

    function getTopbar() {
        return (
            <div className="services-topbar">
                <div className="services-topbar-content">
                    {
                        selectedSubTopbarItem.Features.map((x, j) => {
                            return (
                                <div
                                    key={j}
                                    className={x.id === selectedTopbarItem.id ? "services-topbar-item services-topbar-item-active" : "services-topbar-item"}
                                    onClick={(event) => { handleTopbarClick(event, x) }}
                                >
                                    {x.Heading}
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }

    function getClassNames(item) {
        let classNames = "";
        if (item.IsSubTree) {
            classNames += "services-sub-tree";
        }
        if (item.Type === "table") {
            classNames += "services-table";
        }
        if (item.ClassNames && item.ClassNames.length > 0) {
            item.ClassNames.map(x => {
                classNames += x + " ";
            })
        }
        return classNames.trim();
    }

    function getListData(item) {
        return item.Content.map((a, i) => {
            let content = " " + a.Description + " ";
            if (a.Links && a.Links.length > 0) {
                a.Links.map(x => {
                    let link;
                    if (x.Type === "text anchor") {
                        link = `<a href=${x.Url} target='_blank'>${x.Text}</a>`;
                    }
                    else if (x.Type === "button anchor") {
                        link = `<a href=${x.Url} target='_blank'><button>${x.Text}</button></a>`;
                    }
                    content = content.replaceAll(x.ReplaceText, link);
                });
            }
            if (content.includes("{amatya-email}")) {
                content = content.replaceAll("{amatya-email}", "'" + contactUsJson.email + "'")
            }
            if (item.IsNotList) {
                if (item.ShowAsParagraph) {
                    return (
                        <div key={i}>
                            {
                                a.Title ?
                                    <div className={a.ClassNames ? getClassNames(a) : undefined}>
                                        <b>
                                            {a.Title}
                                        </b>
                                    </div> : ""
                            }
                            <div dangerouslySetInnerHTML={{ __html: content }} />
                        </div>
                    )
                }
                else {
                    return (
                        <div key={i} className={a.ClassNames ? getClassNames(a) : undefined}>
                            {
                                a.Title ?
                                    <b>
                                        {a.Title}
                                    </b> : ""
                            }
                            <span dangerouslySetInnerHTML={{ __html: content }} />
                        </div>
                    )
                }
            }
            else {
                return (
                    <li key={i} className={getClassNames(a)}>
                        {
                            a.Title ?
                                <b>
                                    {a.Title}
                                </b> : ""
                        }
                        <span dangerouslySetInnerHTML={{ __html: content }} />
                    </li>
                )
            }
        });
    }

    function getText(item, Count) {
        let content = item.Content + " ";
        if (content.includes("{amatya-email}")) {
            content = content.replaceAll("{amatya-email}", "'" + contactUsJson.email + "'")
        }
        if (item.Links && item.Links.length > 0) {
            item.Links.map(x => {
                let link;
                if (x.Type === "text anchor") {
                    link = `<a href=${x.Url} target='_blank'>${x.Text}</a>`;
                }
                else if (x.Type === "button anchor") {
                    link = `<a href=${x.Url} target='_blank'><button>${x.Text}</button></a>`;
                }
                content = content.replaceAll(x.ReplaceText, link);
            });
        }
        return (
            <div key={Count} className={getClassNames(item)} dangerouslySetInnerHTML={{ __html: content }} />
        );
    }

    function getJsonArray(item, Count) {
        return (
            <div key={Count} className={getClassNames(item)}>
                {
                    item.IsNotList ?
                        getListData(item)
                        :
                        item.ListType && item.ListType === "Ordered" ?
                            <ol type={item.ListOrderType} className={getClassNames(item)}>
                                {getListData(item)}
                            </ol>
                            :
                            <ul style={{ "listStyleType": "circle" }} className={getClassNames(item)}>
                                {getListData(item)}
                            </ul>
                }
            </div>
        );
    }

    function getTable(item, Count) {
        return (
            <table key={Count} className={getClassNames(item)}>
                <thead>
                    <tr>
                        {
                            item.Header.map((x, iCount) => {
                                return (
                                    <th key={iCount}>
                                        {x}
                                    </th>
                                );
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        item.Body.map((i, iCount) => {
                            return (
                                <tr key={iCount}>
                                    {
                                        i.map((x, xCount) => {
                                            return (
                                                <td key={xCount} rowSpan={x.RowSpan ? x.RowSpan : 1} colSpan={x.ColSpan ? x.ColSpan : 1}>
                                                    {
                                                        x.Type === "text" ? getText(x) : x.Type === "json array" ? getJsonArray(x) : x.Type === "table" ? getTable(x) : ""
                                                    }
                                                </td>
                                            );
                                        })
                                    }
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        );
    }

    function getDescription() {
        return (
            <div className="services-description">
                {
                    selectedTopbarItem.Data.map((item, iCount) => {
                        if (item.Type === "text") {
                            return getText(item, iCount);
                        }
                        else if (item.Type === "json array") {
                            return getJsonArray(item, iCount);
                        }
                        else if (item.Type === "table") {
                            return getTable(item, iCount);
                        }
                        else return "";
                    })
                }
            </div>
        )
    }

    function getDescriptionNew() {
        return (
            <div className="services-description">
                {
                    selectedSubTopbarItem.Features.map((x, index) => {
                        return (
                            <div key={index} className='services-description-container'>
                                {
                                    x.Heading && <div className='services-description-heading'>
                                        {x.Heading}
                                    </div>
                                }
                                {
                                    x.Data.map((item, iCount) => {
                                        if (item.Type === "text") {
                                            return getText(item, iCount);
                                        }
                                        else if (item.Type === "json array") {
                                            return getJsonArray(item, iCount);
                                        }
                                        else if (item.Type === "table") {
                                            return getTable(item, iCount);
                                        }
                                        else return "";
                                    })
                                }
                            </div>
                        );
                    })
                }
            </div>
        )
    }

    return (
        serviceDetails ?
            <div className="services">
                <div className="services-container">
                    <div className="services-header">
                        <div className="services-header-text">
                            {serviceDetails.Heading}
                        </div>
                    </div>
                    <div className="services-content">
                        {getSubTopbar()}
                        <div className="services-body">
                            {/* {getTopbar()} */}
                            {getDescriptionNew()}
                        </div>
                    </div>
                </div>
            </div>
            : <React.Fragment />
    );
}

export default Services;
